import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { setCompassFailed, setCompassSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* setCompass(action) {
  try {
    const { direction_type, id } = action.payload;
    const url = `${BACKEND_URL}/set-compass`;
    const dataResponse = yield makeRequest(url, { direction_type, id }, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(setCompassSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(setCompassFailed());
      yield call(rejectActionPromise(action, data.data));
    }
  } catch (e) {
    yield put(setCompassFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
